import Link from './Link.wrapper';

export default Link;
export { Link };
